import findNextEnabledIndex from './find-next-enabled-index';
import { DOWN_ARROW_KEY, LEFT_ARROW_KEY, RIGHT_ARROW_KEY, UP_ARROW_KEY } from '../../../../../const/keyNames';
export const isDisabled = (index, ineligibleDays) => ineligibleDays.includes(index + 1);
export const handleRight = ({ index, col, row, numbersLength, ineligibleDays }) => {
    if (col < row - 1) {
        const nextIndex = findNextEnabledIndex('right', ineligibleDays, isDisabled, numbersLength, index + 1);
        if (nextIndex !== -1 &&
            Math.floor(nextIndex / row) === Math.floor(index / row)) {
            return nextIndex;
        }
    }
    const downRowIndex = index + row;
    const nextIndex = findNextEnabledIndex('right', ineligibleDays, isDisabled, numbersLength, downRowIndex - col);
    return nextIndex !== -1 && nextIndex < numbersLength ? nextIndex : index;
};
export const handleLeft = ({ index, col, row, numbersLength, ineligibleDays }) => {
    if (col > 0) {
        return findNextEnabledIndex('left', ineligibleDays, isDisabled, numbersLength, index - 1);
    }
    const upColumnIndex = index - row;
    return upColumnIndex >= 0
        ? findNextEnabledIndex('left', ineligibleDays, isDisabled, numbersLength, upColumnIndex + (row - 1))
        : index;
};
export const handleDown = ({ index, row, numbersLength, ineligibleDays }) => {
    const downIndex = index + row;
    if (downIndex < numbersLength) {
        const nextIndex = findNextEnabledIndex('right', ineligibleDays, isDisabled, numbersLength, downIndex);
        if (isDisabled(nextIndex, ineligibleDays)) {
            return findNextEnabledIndex('left', ineligibleDays, isDisabled, numbersLength, downIndex);
        }
        return nextIndex;
    }
    return index;
};
export const handleUp = ({ index, row, numbersLength, ineligibleDays }) => {
    const upIndex = index - row;
    if (upIndex >= 0) {
        const nextIndex = findNextEnabledIndex('left', ineligibleDays, isDisabled, numbersLength, upIndex);
        if (isDisabled(nextIndex, ineligibleDays)) {
            return findNextEnabledIndex('right', ineligibleDays, isDisabled, numbersLength, upIndex);
        }
        return nextIndex;
    }
    return index;
};
export const handleKeyDown = ({ event, index, row, numbersLength, ineligibleDays, setFocusedIndex }) => {
    const col = index % row;
    const handlers = {
        [RIGHT_ARROW_KEY]: () => handleRight({
            index,
            col,
            row,
            numbersLength,
            ineligibleDays
        }),
        [LEFT_ARROW_KEY]: () => handleLeft({
            index,
            col,
            row,
            numbersLength,
            ineligibleDays
        }),
        [DOWN_ARROW_KEY]: () => handleDown({
            index,
            col,
            row,
            numbersLength,
            ineligibleDays
        }),
        [UP_ARROW_KEY]: () => handleUp({
            index,
            col,
            row,
            numbersLength,
            ineligibleDays
        })
    };
    const key = event.key;
    const nextIndex = handlers[key]?.() ?? index;
    if (nextIndex !== index)
        setFocusedIndex(nextIndex);
};
